module.exports = __webpack_public_path__ + "static/media/et.1d986679.svg";